import {
  type ForwardedRef,
  type ElementType,
  type ComponentPropsWithRef,
} from "react";
import { type PropsWithOptionalTestID } from "@boi/components-core";
import { forwardRefGenerics } from "@boi/react-utils";

import * as S from "./LinkBase.styled";
import type { LinkBaseDisplay } from "./LinkBase.types";

type BaseProps = PropsWithOptionalTestID & {
  display?: LinkBaseDisplay;
  isUnderlined?: boolean;
  isDashed?: boolean;
};

type DistributiveOmit<T, TOmitted extends PropertyKey> = T extends any
  ? Omit<T, TOmitted>
  : never;

export type LinkBaseProps<T extends ElementType> = BaseProps & {
  component?: T;
} & DistributiveOmit<
    ComponentPropsWithRef<ElementType extends T ? "a" : T>,
    "component"
  >;

function UnwrappedLinkBase<T extends ElementType>(
  props: LinkBaseProps<T>,
  ref: ForwardedRef<any>
) {
  const {
    display = "inline",
    component = "a",
    testID = "link",
    ...otherProps
  } = props;

  return (
    <S.Container
      {...(otherProps as any)}
      ref={ref}
      as={component}
      data-testid={testID}
      $display={display}
    />
  );
}

export default forwardRefGenerics(UnwrappedLinkBase);
